import styles from './Text.module.css';
import { getClasses } from '@/_utils/classnames';
import type { FC } from 'react';
import type { TextProps } from './Text.types';

export const Text: FC<TextProps> = ({
  children,
  className,
  color = 'primary',
  fontFamily,
  fontWeight,
  isBreakAll,
  onClick,
  isEllipsis,
  takeAvailableSpace,
  isYCentered,
  lineClamp,
  noWrap,
  textAlign = 'left',
  type = 'div',
  underline,
  isItalic = false,
  'data-testid': dataTestId,
}) => {
  const textClasses: string = getClasses(styles.text, className, {
    'text-accent': color === 'accent',
    'text-teal': color === 'teal',
    'text-caution': color === 'caution',
    'text-critical': color === 'critical',
    'text-disabled': color === 'disabled',
    'text-primary': color === 'primary',
    'text-tertiary': color === 'tertiary',
    'text-secondary': color === 'secondary',
    'text-success': color === 'success',
    'text-primary-on-color': color === 'primary-on-color',
    'text-currentcolor': color === 'currentcolor',
    'text-blue': color === 'blue',
    'text-green': color === 'green',
    'text-brown': color === 'brown',
    'text-purple': color === 'purple',
    'text-body': type === 'div' || type === 'paragraph',
    'text-small': type === 'small',
    'text-tiny': type === 'tiny',
    'text-micro': type === 'micro',
    'text-semi-bold': fontWeight === 'semi-bold',
    'text-medium': fontWeight === 'medium',
    'text-bold': fontWeight === 'bold',
    'text-font-mono': fontFamily === 'mono',
    'text-font-serif': fontFamily === 'serif',
    [styles.textCenter]: textAlign === 'center',
    [styles.textLeft]: textAlign === 'left',
    [styles.textRight]: textAlign === 'right',
    [styles.textEllipsis]: isEllipsis,
    [styles.textTakeAvailableSpace]: takeAvailableSpace,
    [styles.textNoWrap]: noWrap,
    [styles.textLineClamp]: !!lineClamp,
    [styles.textLineClamp1]: lineClamp === 1,
    [styles.textLineClamp2]: lineClamp === 2,
    [styles.textLineClamp3]: lineClamp === 3,
    [styles.textWordBreakAll]: isBreakAll,
    [styles.textFlexYCentered]: isYCentered,
    [styles.textHoverable]: !!onClick,
    [styles.textUnderline]: underline,
    [styles.textItalic]: isItalic,
  });

  if (type === 'small' || type === 'tiny' || type === 'micro') {
    return (
      <small className={textClasses} onClick={onClick} data-testid={dataTestId}>
        {children}
      </small>
    );
  }
  if (type === 'paragraph') {
    return (
      <p className={textClasses} onClick={onClick} data-testid={dataTestId}>
        {children}
      </p>
    );
  }

  return (
    <div className={textClasses} onClick={onClick} data-testid={dataTestId}>
      {children}
    </div>
  );
};
